// extracted by mini-css-extract-plugin
export default {"table":"ProcessingHistoryTable_table__T0n7n"};